import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/audits/$auditId")({
  component: () => <Outlet />,
});
